// Shared subject-name normalisation for the intentions subject pickers.
//
// Grid class names sometimes carry a trailing " / SUBJECTCODE" variant suffix,
// so multiple line variants of the same subject must collapse to one option.
//   "PASSION - PHOTOGRAPHY / RURUAPHOA" -> "PASSION - PHOTOGRAPHY"
//   "FOCUS - SCIENCE - BIOLOGY"          -> "FOCUS - SCIENCE - BIOLOGY"
//   "ACCOUNTING12"                       -> "ACCOUNTING12"
export function normalizeSubjectName(className: string): string {
  const slashIndex = className.indexOf(' / ');
  return (slashIndex === -1 ? className : className.slice(0, slashIndex)).trim();
}
